var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between text-sm",class:_vm.margin},[_c('div',{staticClass:"text-gray-700"},[_vm._t("left")],2),_c('div',{staticClass:"flex-1 text-right"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }